import React, { useEffect, useRef } from 'react'
import { Marker, useMap, Popup } from 'react-leaflet'

const LeafletMapMarker = ({
  children,
  active,
  position,
  ...leafletMarkerProps
}) => {
  const map = useMap()
  const popupEl = useRef()

  useEffect(() => {
    if (active && position && popupEl.current) {
      map.openPopup(popupEl.current, position)
    }
  }, [active, position, map])

  return (
    <Marker position={position} {...leafletMarkerProps}>
      <Popup ref={popupEl}>{children}</Popup>
    </Marker>
  )
}

export default LeafletMapMarker
